import { serverDate } from 'shared/locale/datetime.js';

const LOW_PRICE_THRESHOLD_ELEMENT = 3;

export function lowfareWithNewPriceAndSearchId(lowfare, departureDate, returnDate, price, searchId) {
    const deepCopy = lowfare.map(dep => {
        if (dep.departureDate === departureDate) {
            const returns = dep.returnFlight.map(ret =>
                ret.date === returnDate ? { date: ret.date, price, searchId } : Object.assign(ret)
            );
            if (!returns.find(ret => ret.date === returnDate)) {
                returns.push({ date: returnDate, price, searchId });
            }
            return { departureDate: dep.departureDate, returnFlight: returns };
        }
        return { departureDate: dep.departureDate, returnFlight: dep.returnFlight.map(ret => Object.assign(ret)) };
    });
    if (!deepCopy.find(dep => dep.departureDate === departureDate)) {
        deepCopy.push({ departureDate, returnFlight: [{ date: returnDate, price, searchId }] });
    }
    return deepCopy;
}

export function getPriceData(lowfare, departureDate, returnDate) {
    return (
        lowfare
            .filter(dep => dep.departureDate === departureDate)
            .map(dep =>
                dep.returnFlight
                    .filter(ret => ret.date === returnDate)
                    .map(ret => ({ price: parseInt(ret.price), searchId: ret.searchId }))
                    .shift()
            )
            .shift() || {}
    );
}

export function getPriceArray(lowfare, compare) {
    if (lowfare) {
        return lowfare
            .filter(compare)
            .map(yolofare => yolofare.returnFlight.map(returnFlight => parseInt(returnFlight.price)))
            .reduce((acc, val) => acc.concat(val), []) // single level flatten
            .filter((val, idx, self) => self.indexOf(val) === idx);
    }
}

export function getPricesForEarlierPeriod(lowfare, centerDepartureDate, slack) {
    const compare = yolofare => serverDate(yolofare.departureDate).isBefore(serverDate(centerDepartureDate).subtract(slack, 'days'));
    return getPriceArray(lowfare, compare);
}

export function getPricesForLaterPeriod(lowfare, centerDepartureDate, slack) {
    const compare = yolofare => serverDate(yolofare.departureDate).isAfter(serverDate(centerDepartureDate).add(slack, 'days'));
    return getPriceArray(lowfare, compare);
}

export function getPriceArrayForPeriod(lowfare, centerDepartureDate, slack) {
    const compare = yolofare =>
        serverDate(yolofare.departureDate).isAfter(serverDate(centerDepartureDate).subtract(slack + 1, 'days')) &&
        serverDate(yolofare.departureDate).isBefore(serverDate(centerDepartureDate).add(slack + 1, 'days'));
    return getPriceArray(lowfare, compare);
}

export function getLowestPrice(priceArray = []) {
    return priceArray.length > 0 ? Math.min(...priceArray) : null;
}

export function getLowPriceThreshold(priceArray = []) {
    priceArray.sort((a, b) => a - b);

    // need extra logic for when number of lowPrice elements is lower then LOW_PRICE_THRESHOLD_FROM_ELEMENT
    const lowPriceThresholdElement =
        priceArray.length > LOW_PRICE_THRESHOLD_ELEMENT ? LOW_PRICE_THRESHOLD_ELEMENT : Math.floor(priceArray.length / 2);
    return priceArray[lowPriceThresholdElement]; // .slice( lowPriceThresholdElement, lowPriceThresholdElement + 1);
}

export function getPriceBackground(price, lowestPrice, lowPriceThreshold) {
    if (!price || (lowPriceThreshold && price > lowPriceThreshold)) {
        // normal price, over lowPriceThreshold
        return '';
    } else if (price === lowestPrice) {
        // else if lowest price
        return 'u-bg-pea';
    } else {
        // else low price
        return 'u-bg-mint';
    }
}

export function isCurrentDateOutsideTable(currentDepartureDate, currentReturnDate, centerDeparture, centerReturn, slack) {
    const currentDeparture = serverDate(currentDepartureDate);
    const currentReturn = serverDate(currentReturnDate);

    return (
        currentDeparture.isBefore(serverDate(centerDeparture).subtract(slack, 'days')) ||
        currentDeparture.isAfter(serverDate(centerDeparture).add(slack, 'days')) ||
        currentReturn.isBefore(serverDate(centerReturn).subtract(slack, 'days')) ||
        currentReturn.isAfter(serverDate(centerReturn).add(slack, 'days'))
    );
}

export function hasPriceStats(data) {
    return !!(data && data.stats && data.stats.price && data.stats.price.min);
}
